import { cn } from "@/lib/utils";

export interface CrmTaskOperatorBriefEntry {
  label: string;
  value: string;
}

interface CrmTaskOperatorPreviewCardProps {
  context?: string | null;
  guidance?: string | null;
  briefEntries?: CrmTaskOperatorBriefEntry[];
  className?: string;
}

export function CrmTaskOperatorPreviewCard({
  context,
  guidance,
  briefEntries = [],
  className,
}: CrmTaskOperatorPreviewCardProps) {
  const safeContext = context?.trim() || null;
  const safeGuidance = guidance?.trim() || null;
  const visibleBriefEntries = briefEntries
    .map((entry) => ({ label: entry.label.trim(), value: entry.value.trim() }))
    .filter((entry) => entry.label && entry.value);

  if (!safeContext && !safeGuidance && visibleBriefEntries.length === 0) {
    return null;
  }

  return (
    <div className={cn(
      "grid gap-2 rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-2 md:grid-cols-2",
      className,
    )}>
      {safeContext ? (
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--color-muted-foreground)]">
            Why
          </p>
          <p className="mt-0.5 line-clamp-2 text-sm text-[var(--color-foreground)]">
            {safeContext}
          </p>
        </div>
      ) : null}
      {safeGuidance ? (
        <div className="rounded-md border border-[var(--color-primary)]/20 bg-[var(--color-primary)]/5 px-2 py-1.5">
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--color-primary)]">
            Staff action
          </p>
          <p className="mt-0.5 line-clamp-2 text-sm text-[var(--color-foreground)]">
            {safeGuidance}
          </p>
        </div>
      ) : null}
      {visibleBriefEntries.length > 0 ? (
        <div className="md:col-span-2">
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--color-muted-foreground)]">
            Key facts
          </p>
          <div className="mt-1 flex flex-wrap gap-1.5">
            {visibleBriefEntries.map((entry) => (
              <span
                key={`${entry.label}:${entry.value}`}
                className="rounded-full border border-[var(--color-border)] bg-[var(--color-surface)] px-2 py-0.5 text-xs text-[var(--color-muted-foreground)]"
              >
                <span className="font-medium text-[var(--color-foreground)]">{entry.label}:</span> {entry.value}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
